const STORAGE_KEY = "theofast-test-mode";
let sessionTestMode = false;

export function configureTestMode() {
  const url = new URL(window.location.href);
  const setting = url.searchParams.get("test");
  if (setting !== "1" && setting !== "0") return;
  sessionTestMode = setting === "1";
  try {
    window.localStorage.setItem(STORAGE_KEY, sessionTestMode ? "1" : "0");
  } catch { /* Keep the choice for this page when storage is unavailable. */ }
  // Do not accidentally enable test mode for someone receiving a shared URL.
  url.searchParams.delete("test");
  window.history.replaceState(window.history.state, "", url.pathname + url.search + url.hash);
}

export function isTestMode() {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === "1" || sessionTestMode;
  } catch {
    return sessionTestMode;
  }
}
